import React from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';

import getAreaConfig from './AreaConfig';
import NoChartsData from '../../no-charts-data/NoChartsData';

import css from './Area.module.scss';

function Area({ data, dataKey, isShowTrend, title }) {
  const theme = useSelector((state) => state.global.theme);

  if (!data.length) {
    return <NoChartsData height='450px' />;
  }

  const series = [
    {
      name: 'Score',
      data: data.map((el) => el?.[dataKey]?.score),
    },
  ];

  isShowTrend &&
    series.push({
      name: 'Trend',
      data: data.map((el) => el?.[dataKey]?.trend),
    });

  const options = getAreaConfig(data, theme, title, dataKey, isShowTrend);

  return (
    <div className={css.chart}>
      <Chart series={series} options={options.options} type='area' height={450} />
    </div>
  );
}

export default Area;
